import { mediaMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

interface HeaderProps {
  $hideOnMobile?: boolean;
  $isMobile?: boolean;
}

export const StyledHeader = styled.header<HeaderProps>`
  display: grid;
  grid-template-rows: repeat(2, 1fr);
  grid-template-columns: repeat(auto-fill, 24px);
  margin: auto;
  align-items: center;
  justify-items: center;
  width: 100%;

  @media screen and (min-width: 768px) and (max-width: 991px) {
    max-width: 768px;
  }

  @media screen and (min-width: 992px) and (max-width: 1023px) {
    max-width: 100%;
  }

  ${mediaMixin(
    'xxl',
    css`
      && {
        display: inline-flex;
        padding: 21px 0;
        max-width: 1232px;
        width: 100%;
        margin-left: 0;
      }
    `,
  )}

  ${(props) =>
    props.$hideOnMobile &&
    css`
      display: none;
    `}
`;

export const StyledFiltersModuleContainer = styled.div`
  grid-row: 2 / 3;
  grid-column: 1 / 3;

  ${mediaMixin(
    'xl',
    css`
      margin-left: auto;
    `,
  )}
`;

export const StyledViewByModuleContainer = styled.div`
  grid-column: 7/13;
  border-left: 1px solid ${token('colors.gray300')};
  padding-left: 12px;
  height: fit-content;
  display: flex;
  justify-self: start;

  ${mediaMixin(
    'xl',
    css`
      margin-left: 12px;
    `,
  )}
`;
